import type { BadgeVariant } from '@picsart/design-system/components/Badge';

/**
 * Maps a subscription tier id to the DS avatar/badge variant. Returns undefined
 * for free / unknown tiers (no badge).
 */
const tierToBadge = (
  tierId: string | null | undefined
): BadgeVariant | undefined => {
  if (!tierId) return undefined;
  const id = tierId.toLowerCase();
  if (id.includes('ultra')) return 'ultra';
  if (id.includes('pro')) return 'pro';
  if (id.includes('plus')) return 'plus';
  return undefined;
};

export default tierToBadge;
